var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.type==0)?_c('images',{attrs:{"imgList":_vm.details}}):(_vm.type==1)?_c('document',{attrs:{"source":_vm.details}}):_vm._e(),_vm._v(" "),_c('back',{attrs:{"category_id":_vm.category_id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a4c6bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/details.vue
// module id = null
// module chunks = 